export default __webpack_public_path__ + "static/media/shipping-primary.b25bdc70.svg";